<div class="dg-modal-header">
    <span class="dg-modal-header__title">{{ popupTitle }}</span>
</div>

<div class="dg-modal-body">
    <div class="form-group">
        <span class="form-label">Replacement reason</span>
        <ui-multi-dropdown
            [optionsList]="requestListFilters.badgeRequestReasonName"
            (onSelected)="checkSelectedItem($event,'badgeRequestReasonName')"
        ></ui-multi-dropdown>
    </div>
    <div class="form-group mobile-range-datepicker">
        <span class="form-label">Date (UTC)</span>
        <div>
            <ui-date-range-picker
                [start]="selectedRequestedDateStart"
                [end]="selectedRequestedDateEnd"
                [hasSort]="false"
                [showInput]="true"
                [hideCursor]="true"
                [bsConfig]="bsConfig"
                [columnName]="'requestedDate'"
                [positionDateRange]="'mobile-bottom-center'"
                [isSettingDefaultDate]="false"
                (dateRangeChanged)="selectRequestedDate($event.dateRange)"
            ></ui-date-range-picker>
        </div>
    </div>
    <div class="form-group">
        <span class="form-label">Photo status</span>
        <ui-multi-dropdown
            [showListOnTop]="true"
            [optionsList]="requestListFilters.photoRequestStatusName"
            (onSelected)="checkSelectedItem($event,'photoRequestStatusName')"
        ></ui-multi-dropdown>
    </div>
    <div class="form-group">
        <span class="form-label">Badge status</span>
        <ui-multi-dropdown
            [showListOnTop]="true"
            [optionsList]="requestListFilters.badgeRequestStatusName"
            (onSelected)="checkSelectedItem($event,'badgeRequestStatusName')"
        ></ui-multi-dropdown>
    </div>
</div>

<div class="dg-modal-footer">
    <button
        *ngIf="showButtonNo"
        appTrackClickButton
        id="dismiss"
        type="button"
        class="button secondary"
        (click)="action(false)"
    >
        {{ buttonsTitle.dismiss }}
    </button>
    <button
        *ngIf="showButtonYes"
        appTrackClickButton
        id="confirm"
        type="button"
        class="button primary"
        (click)="applyFiltering()"
    >
        {{ buttonsTitle.confirm }}
    </button>
</div>

